import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
  *,
  *::after,
  *::before {
    box-sizing: border-box;
  }

  body {
    align-items: center;
    background: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
    display: flex;
    font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
    transition: all 0.25s linear;
    min-height: 100vh;
  }

  /* Custom Scrollbar */
  ::-webkit-scrollbar {
    width: 8px;
  }
  
  ::-webkit-scrollbar-track {
    background: #0a0a0f;
  }
  
  ::-webkit-scrollbar-thumb {
    background: #6c5ce7;
    border-radius: 4px;
  }
  
  ::-webkit-scrollbar-thumb:hover {
    background: #a29bfe;
  }

  /* Selection */
  ::selection {
    background: #6c5ce7;
    color: #ffffff;
  }

  /* Links */
  a {
    color: #6c5ce7;
    text-decoration: none;
    transition: all 0.3s ease;
  }
  
  a:hover {
    color: #a29bfe;
  }
`;
